@if (showInfoCard) {
  @if (session$ | async; as session) {
    @if (settings$ | async; as settings) {
      @if (!(isPinned$ | async)) {
        <ng-container
          *ngTemplateOutlet="infoCardTpl; context: { session: session, settings: settings }"
        ></ng-container>
      }
    }
  }

  <ng-template #infoCardTpl let-session="session" let-settings="settings">
    <div
      class="info-card-wrapper"
      [class.info-card-wrapper--toolbar]="(isPinned$ | async) === true"
      [class.scrolling]="pinnedInfoScrollTransparencyEffect && isScrolling"
    >
      <ion-card>
        <ion-card-header>
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
              gap: 1rem;
            "
          >
            @if (session.thumbnailUrl) {
              <ion-thumbnail class="session-thumbnail">
                <ion-img
                  [src]="session.thumbnailUrl"
                  (ionError)="session.thumbnailUrl = undefined"
                  (ionImgDidLoad)="$event.target.classList.add('loaded')"
                  class="thumbnail-image"
                ></ion-img>
              </ion-thumbnail>
            }
            <div style="flex: 1">
              <ion-card-subtitle>
                @if (session.workspace) {
                  {{ session.workspace.name }}
                  @if (settings.showFirestoreIds) {
                    • ID: {{ session.workspace.id }}
                  }
                }
              </ion-card-subtitle>
              <ion-card-title>{{ session.name }}</ion-card-title>
              <ion-card-subtitle>
                @if (settings.showFirestoreIds && (!session.workspace || session.id)) {
                  @if (session.workspace && session.name) {
                    <br />
                  }
                  Session ID: {{ session.id || (sessionId$ | async) }}
                }
              </ion-card-subtitle>
            </div>
            <div style="display: flex; align-items: center; gap: 0.5rem">
              <ion-button
                fill="clear"
                size="small"
                (click)="togglePin()"
                [attr.aria-label]="(isPinned$ | async) ? 'Unpin session info' : 'Pin session info'"
              >
                <ion-icon
                  [name]="(isPinned$ | async) ? 'remove-circle' : 'pin'"
                  slot="icon-only"
                ></ion-icon>
              </ion-button>
            </div>
          </div>
        </ion-card-header>
      </ion-card>
    </div>
  </ng-template>
}
